import PropTypes from 'prop-types';
import { Box, Dialog, DialogContent, DialogTitle, Link, MenuItem, Select } from '@mui/material';
import { Link as ReactLink } from 'react-router-dom';
import i18n from '@/i18n'
import { gql, useMutation } from '@apollo/client';

const UPDATE_RELEASE_MUTATION = gql`
  mutation updateRelease($releaseId: ID!, $pitchStatus: String!) {
    updateRelease(
      releaseId: $releaseId,
      pitchStatus: $pitchStatus
    ) {
      ok
    }
  }
`

import {
  ReleaseCardStyled,
  ReleaseTitle,
  ReleaseArtist,
  ReleaseDetails,
  ReleaseLabel,
  StatusBadge,
} from './DashboardStyles';

const PITCH_STATUSES = [
  {
    id: 'focus-label',
    name: 'Focus label'
  },
  {
    id: 'pending',
    name: 'Pending'
  },
  {
    id: 'submitted',
    name: 'Submitted'
  }
]

export function ReleaseCard({
  id,
  name,
  label,
  artists,
  slug,
  pitchStatus,
  released,
  playlist,
  genreName,
  onUpdateRelease,
  animationDelay = 0,
}) {
  const [updateRelease, { loading: updatingRelease }] = useMutation(
    UPDATE_RELEASE_MUTATION
  )

  return (
    <ReleaseCardStyled sx={{ animationDelay: `${animationDelay}s` }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 1,
        }}
      >
        <Box>
          <ReleaseTitle>
            <Link as={ReactLink} to={`/dashboard/release/${slug}`}>
              {name}
            </Link>
          </ReleaseTitle>
          <ReleaseArtist>{artists?.map(artist => artist.name).join(', ')}</ReleaseArtist>
          <ReleaseLabel>{label?.name}</ReleaseLabel>
        </Box>
      </Box>
      <ReleaseDetails>
        <span>📅 {released}</span>
        <span>🎯 {playlist ?? '-'}</span>
        <span>🎸 {genreName ?? 'Unknown'}</span>
      </ReleaseDetails>
    </ReleaseCardStyled>
  );
}

ReleaseCard.propTypes = {
  title: PropTypes.string.isRequired,
  artist: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['pending', 'submitted', 'focus']).isRequired,
  releaseDate: PropTypes.string.isRequired,
  playlist: PropTypes.string.isRequired,
  genreName: PropTypes.string.isRequired,
  animationDelay: PropTypes.number,
};
